export default __webpack_public_path__ + "static/media/Illuminating Atlantean Catalyst.baa514e8.jpg";